// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1BBDh","left":"StickyBox_left__3Trdo","right":"StickyBox_right__1Ol19"};